import {ParcelIncident} from '@domain/model/Account/ParcelIncident';
import {ViewParcelIncidentByUserIdQuery} from '@domain/model/Account/ParcelIncident/ViewParcelIncidentByUserIdQuery';

type ParcelIncidentRepository = {
  viewParcelIncidentByUserId(query: ViewParcelIncidentByUserIdQuery): Promise<ParcelIncident | null>;
};

const ViewParcelIncidentByUserId =
  (repository: ParcelIncidentRepository) =>
  (query: ViewParcelIncidentByUserIdQuery): Promise<ParcelIncident | null> => {
    if (!query?.userId) {
      return Promise.resolve(null);
    }

    return repository.viewParcelIncidentByUserId(query);
  };

export {ViewParcelIncidentByUserId};
